import { render } from "./CreateBuyInOffer.vue?vue&type=template&id=3bddc748&scoped=true"
import script from "./CreateBuyInOffer.vue?vue&type=script&lang=js"
export * from "./CreateBuyInOffer.vue?vue&type=script&lang=js"

import "./CreateBuyInOffer.vue?vue&type=style&index=0&id=3bddc748&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bddc748"]])

export default __exports__